import React, { useEffect, useState } from "react";
import { Trash2, ShieldCheck, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "");

export function AdminCleanup() {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState({ vendors: new Set(), orders: new Set(), reviews: new Set() });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/cleanup/preview").then((r) => {
    setData(r.data);
    setSel({ vendors: new Set(r.data.vendors.map((v) => v.id)), orders: new Set(r.data.orders.map((o) => o.id)), reviews: new Set(r.data.reviews.map((x) => x.id)) });
  }).catch(() => toast.error("Aperçu indisponible"));
  useEffect(() => { load(); }, []);

  const toggle = (k, id) => setSel((s) => { const n = new Set(s[k]); n.has(id) ? n.delete(id) : n.add(id); return { ...s, [k]: n }; });
  const total = sel.vendors.size + sel.orders.size + sel.reviews.size;

  const run = async () => {
    if (!window.confirm(`Supprimer définitivement ${sel.vendors.size} boutique(s), ${sel.orders.size} commande(s) et ${sel.reviews.size} avis ? Cette action est irréversible.`)) return;
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/cleanup/execute", { vendor_ids: [...sel.vendors], order_ids: [...sel.orders], review_ids: [...sel.reviews] });
      toast.success(`Supprimé : ${r.deleted.vendors} boutique(s), ${r.deleted.orders} commande(s), ${r.deleted.reviews} avis`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };

  if (!data) return <p className="text-zinc-500">Analyse en cours…</p>;
  const Section = ({ title, k, rows, render }) => (
    <div className="border border-zinc-800 bg-ink-surface p-4">
      <h3 className="font-anton uppercase text-white mb-2">{title} <span className="text-neon-magenta">({rows.length})</span></h3>
      {rows.length === 0 ? <p className="text-zinc-600 text-sm">Rien à supprimer.</p> : (
        <div className="space-y-1 max-h-72 overflow-y-auto">
          {rows.map((r) => (
            <label key={r.id} data-testid={`cleanup-${k}-row`} className="flex items-start gap-2 text-sm text-zinc-300 cursor-pointer hover:text-white">
              <input type="checkbox" checked={sel[k].has(r.id)} onChange={() => toggle(k, r.id)} className="accent-[#9dff00] mt-1" />
              <span>{render(r)}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div data-testid="admin-cleanup" className="space-y-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="font-anton text-2xl uppercase text-white">Nettoyage des données de test</h2>
          <p className="text-zinc-500 text-sm flex items-center gap-1.5 mt-1"><ShieldCheck className="h-4 w-4 text-neon-green" /> TOTO, les boutiques Mantes et la boutique nationale ne sont jamais proposées. Rien n'est supprimé sans ta validation : décoche ce que tu veux garder.</p>
        </div>
        <button onClick={load} className="inline-flex items-center gap-1 text-xs uppercase font-bold border border-zinc-700 text-zinc-300 px-3 py-2 hover:border-neon-green"><RefreshCw className="h-3.5 w-3.5" /> Actualiser</button>
      </div>
      <Section title="Boutiques de test" k="vendors" rows={data.vendors} render={(v) => <>{v.name} <span className="text-zinc-500">· {v.email} · {v.city}{v.is_approved ? "" : " · non approuvée"}</span></>} />
      <Section title="Commandes de test" k="orders" rows={data.orders} render={(o) => <>#{o.ref} {o.invoice_number && <span className="text-neon-magenta">{o.invoice_number}</span>} <span className="text-zinc-500">· {o.customer_name} · {o.vendor_name} · {o.status} · {Number(o.total || 0).toFixed(2)}€ · {fmt(o.created_at)}</span></>} />
      <Section title="Avis liés" k="reviews" rows={data.reviews} render={(r) => <>{r.rating}★ <span className="text-zinc-500">· {r.phone} · {fmt(r.created_at)}</span></>} />
      <button data-testid="cleanup-execute" onClick={run} disabled={busy || total === 0} className="inline-flex items-center gap-2 bg-red-600 text-white font-anton uppercase px-5 py-3 hover:bg-red-500 disabled:opacity-40">
        <Trash2 className="h-4 w-4" /> Supprimer la sélection ({total})
      </button>
    </div>
  );
}
